import React from "react";
import { graphql } from "gatsby";
const helpers = require("../helpers");

import Layout from "../components/layout";

import Header from "../components/organisms/header";
import Footer from "../components/organisms/footer";
import Section from "../components/organisms/section";
import OurApproach from "../components/organisms/our-approach";

import HeaderBrand from "../components/molecules/header-brand";
import HeaderTitle from "../components/molecules/header-title";
import FooterBrand from "../components/molecules/footer-brand";
import FooterNav from "../components/molecules/footer-nav";
import FooterCopy from "../components/molecules/footer-copy";
import NavBar from "../components/molecules/navbar";
import ImageButton from "../components/molecules/image-button";
import Professional from "../components/molecules/professional";
import Image from "../components/molecules/image";

import Seo from "../components/atoms/seo";
import Button from "../components/atoms/button";
import DictionaryEntry from "../components/atoms/dictionary-entry";

class AboutUs extends React.Component {
  render() {
    const dictionaryEdges = this.props.data.allContentfulDictionaryEntry.edges;

    const expertises =
      this.props.pageContext.language &&
      this.props.pageContext.language === "nl"
        ? this.props.data.nlExpertise.edges
        : this.props.data.enExpertise.edges;
    const expertisesElements = expertises.map((expertise, index) => {
      return (
        <div className="col-sm-6" key={index}>
          <Professional
            icon={expertise.node.icon.file.url}
            iconAlt={expertise.node.icon.file.title}
            title={expertise.node.title}
            description={expertise.node.description.description}
            link={expertise.node.link ? expertise.node.link : undefined}
            linkText={expertise.node.linkText}
          />
        </div>
      );
    });
    return (
      <Layout location={this.props.location}>
        <Seo
          title={helpers.getShortValueFromDictionary(
            dictionaryEdges,
            "about-us.seo-title",
            this.props.pageContext.language
          )}
          description={helpers.getShortValueFromDictionary(
            dictionaryEdges,
            "about-us.seo-description",
            this.props.pageContext.language
          )}
        />
        <Header>
          <HeaderBrand />
          <NavBar
            context={this.props.pageContext.intl}
            language={this.props.pageContext.language}
          />
        </Header>
        <Section className="pt-5 pb-5">
          <HeaderTitle
            title={helpers.getShortValueFromDictionary(
              dictionaryEdges,
              "about-us.header-title",
              this.props.pageContext.language
            )}
          />
          <div className="row">
            <div className="col-sm-9">
              <p className="mb-4">
                <em>
                  <DictionaryEntry
                    dictionaryEdges={dictionaryEdges}
                    dictionaryKey="about-us.page-introduction"
                    language={this.props.pageContext.language}
                  />
                </em>
              </p>
            </div>
          </div>
        </Section>

        <Section className="">
          <h2>
            <DictionaryEntry
              dictionaryEdges={dictionaryEdges}
              dictionaryKey="about-us.content-title"
              language={this.props.pageContext.language}
            />
          </h2>
          <div className="row">
            <div className="col-sm-6">
              <p>
                <DictionaryEntry
                  dictionaryEdges={dictionaryEdges}
                  dictionaryKey="about-us.content-part-one"
                  language={this.props.pageContext.language}
                />
              </p>
            </div>
            <div className="col-sm-6">
              <p>
                <DictionaryEntry
                  dictionaryEdges={dictionaryEdges}
                  dictionaryKey="about-us.content-part-two"
                  language={this.props.pageContext.language}
                />
              </p>
            </div>
          </div>
        </Section>
        <Section className="section-grey-split pt-5 pb-0 pb-sm-5">
          <div className="row">
            <div className="col-sm-10 ml-auto">
              <ImageButton
                to="solutions"
                fluid={this.props.data.whatwecandoImage.childImageSharp.fluid}
                alt={helpers.getShortValueFromDictionary(
                  dictionaryEdges,
                  "about-us.solutions-teaser.altImage",
                  this.props.pageContext.language
                )}
                title={helpers.getShortValueFromDictionary(
                  dictionaryEdges,
                  "about-us.solutions-teaser.title",
                  this.props.pageContext.language
                )}
              />
            </div>
          </div>
        </Section>
        <Section className="section-grey pt-5 pb-5">
          <div className="row mb-5">
            <div className="col-sm-6">
              <h3 className="mb-4 h4">
                <DictionaryEntry
                  dictionaryEdges={dictionaryEdges}
                  dictionaryKey="about-us.our-expertise.title"
                  language={this.props.pageContext.language}
                />
              </h3>
              <p className="tagline">
                <DictionaryEntry
                  dictionaryEdges={dictionaryEdges}
                  dictionaryKey="about-us.our-expertise.introduction"
                  language={this.props.pageContext.language}
                />
              </p>
            </div>
          </div>
          <div className="row">{expertisesElements}</div>
        </Section>
        <OurApproach
          language={this.props.pageContext.language}
          title={helpers.getShortValueFromDictionary(
            dictionaryEdges,
            "about-us.deliverables.title",
            this.props.pageContext.language
          )}
          ctaTitle={helpers.getShortValueFromDictionary(
            dictionaryEdges,
            "about-us.deliverables.cta-title",
            this.props.pageContext.language
          )}
        />
        <Section className="pt-0 pb-0 section-grey" isFluid={true}>
          <div className="row">
            <div className="col-md-3 mr-auto">
              <Image
                fluid={this.props.data.collaborateImage.childImageSharp.fluid}
                alt={helpers.getShortValueFromDictionary(
                  dictionaryEdges,
                  "about-us.contact-alt-image",
                  this.props.pageContext.language
                )}
                overlay="gradient"
                negateLeft={true}
                negateTop={true}
                aspectRatio="1x3"
              />
            </div>
            <div className="col-md-8 d-flex py-5">
              <div className="mt-auto mb-auto">
                <p className="h3 mb-4">
                  <DictionaryEntry
                    dictionaryEdges={dictionaryEdges}
                    dictionaryKey="about-us.contact-title"
                    language={this.props.pageContext.language}
                  />
                </p>
                <Button to="contact" type="clean">
                  <DictionaryEntry
                    dictionaryEdges={dictionaryEdges}
                    dictionaryKey="about-us.contact-cta"
                    language={this.props.pageContext.language}
                  />
                </Button>
              </div>
            </div>
          </div>
        </Section>
        <Footer>
          <FooterBrand />
          <FooterNav language={this.props.pageContext.language} />
          <FooterCopy />
        </Footer>
      </Layout>
    );
  }
}

export const query = graphql`
  query {
    whatwecandoImage: file(relativePath: { eq: "blastic-vibe/KT0A4655.jpg" }) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        # Makes it trivial to update as your page's design changes.
        fluid(maxWidth: 800, quality: 100) {
          # Choose either the fragment including a small base64ed image, a traced placeholder SVG, or one without.
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    collaborateImage: file(relativePath: { eq: "blastic-vibe/KT0A4728.jpg" }) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        # Makes it trivial to update as your page's design changes.
        fluid(maxWidth: 1000, quality: 100) {
          # Choose either the fragment including a small base64ed image, a traced placeholder SVG, or one without.
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    enExpertise: allContentfulExpertise(
      filter: { node_locale: { eq: "en-EU" } }
    ) {
      edges {
        node {
          id
          title
          description {
            description
          }
          icon {
            title
            file {
              url
            }
          }
          link
          linkText
        }
      }
    }
    nlExpertise: allContentfulExpertise(
      filter: { node_locale: { eq: "nl-BE" } }
    ) {
      edges {
        node {
          id
          title
          description {
            description
          }
          icon {
            title
            file {
              url
            }
          }
          link
          linkText
        }
      }
    }
    allContentfulDictionaryEntry(filter: { key: { regex: "/about-us/i" } }) {
      edges {
        node {
          key
          shortValue
          richValue {
            raw
          }
          node_locale
        }
      }
    }
  }
`;

export default AboutUs;
